import { defineMessages } from 'react-intl'

export const directionNames = defineMessages({
    warsaw: {
        id: 'upsells.transport.direction_warsaw',
        defaultMessage: 'Warszawa',
    },
    zyrardow: {
        id: 'upsells.transport.direction_zyrardow',
        defaultMessage: 'Żyrardów',
    },
    suntago: {
        id: 'upsells.transport.direction_suntago',
        defaultMessage: 'Suntago',
    },
})

export const daysLabels = defineMessages({
    'monday-thursday': {
        id: 'global.days.monday_thursday',
        defaultMessage: 'Pon - Czw',
    },
    friday: {
        id: 'global.days.friday',
        defaultMessage: 'Piątek',
    },
    saturday: {
        id: 'global.days.saturday',
        defaultMessage: 'Sobota',
    },
    sunday: {
        id: 'global.days.sunday',
        defaultMessage: 'Niedziela',
    },
})
